<template>
  <div class="content">
    <div class="content-hander">
      <div class="content-main-title"><span> 光明渔业养殖系统 </span></div>
      <div
        class="content-hander-button"
        @click="goOut"
      >
        <span class="hander-button-tit">退出</span>
      </div>
    </div>
    <div class="content-data">
      <el-row
        :gutter="20"
        type="flex"
        style="min-height: 100%;"
      >
        <el-col :span="6">
          <div class="data-left-one">
            <span class="data-tit">电流实时数据</span>
            <div class="data-left-one-echarts">
              <el-row
                type="flex"
                style="min-height: 100%;"
              >
                <el-col :span="8">
                  <div
                    class="annl"
                    ref="huanOne"
                  ></div>
                </el-col>
                <el-col :span="8">
                  <div
                    class="annl"
                    ref="huanTwo"
                  ></div>
                </el-col>
                <el-col :span="8">
                  <div
                    class="annl"
                    ref="huanThree"
                  ></div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="data-left-two">
            <span class="data-tit">电压实时数据</span>
            <div class="data-left-two-echarts">
              <el-row
                :gutter="20"
                type="flex"
                style="min-height: 30%;"
              >
                <el-col :span="8">
                  <div class="eu-data">
                    <span> 电压A: {{form.eua}}V</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="eu-data">
                    <span> 电压B: {{form.eub}}V</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="eu-data">
                    <span> 电压C: {{form.euc}}V</span>
                  </div>
                </el-col>
              </el-row>
              <div
                class="annl"
                ref="euLine"
              ></div>
            </div>
          </div>
          <div class="data-left-three">
            <span class="data-tit">实时功率/电能</span>
            <div class="data-left-three-eq">
              <div class="eq-gif-left"></div>
              <div class="eq-data"><span>总功率 {{form.ep}}W</span>&nbsp;
                <span>电能 {{form.esp}}KWH</span>
              </div>
              <div class="eq-gif-right"></div>
            </div>
          </div>
          <div class="data-left-four">
            <span class="data-tit">电流电压雷达图</span>
            <div
              class="annl"
              style="height: 90%;padding:15px 15px"
              ref="eleida"
            ></div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="data-middle-one">
            <div class="middle-video">
              <iframe
                id="vid"
                :src="vedioSrc"
                width="100%"
                height="100%"
                allowfullscreen
              >
              </iframe>
            </div>
          </div>
          <div class="data-middle-main-two">
            <el-row
              :gutter="20"
              type="flex"
              style="min-height: 100%;"
            >
              <el-col :span='6'>
                <div class="data-middle-two">
                  <div><span class="data-tit">开关控制</span></div>
                  <div class="data-middle-two-switch">
                    <div
                      class="middle-switch"
                      style="margin-top:15px"
                    >
                      <div
                        style="margin-top:3px"
                        class="tit"
                      ><span>摄像头开关：&nbsp;</span></div>
                      <el-switch
                        style="display: block"
                        v-model="camera"
                        active-color="#13ce66"
                        inactive-color="#34dcfc"
                        inactive-text=""
                        @change='cameraSwitch'
                      ></el-switch>

                    </div>
                    <div
                      class="middle-switch"
                      style="margin-top:5%"
                    >
                      <div class="tit"><span>西增氧机：&nbsp;&nbsp;&nbsp;&nbsp;</span></div>
                      <el-switch
                        style="display: block"
                        v-model="contactorOne"
                        active-color="#13ce66"
                        inactive-color="#34dcfc"
                        inactive-text=""
                        @change='contactorOneSwitch'
                      ></el-switch>

                    </div>
                    <!-- <div
                      class="middle-switch"
                      style="margin-top:5%"
                    >
                      <div class="tit"><span>拌料机：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></div>
                      <el-switch
                        style="display: block"
                        v-model="contactorTwo"
                        active-color="#13ce66"
                        inactive-color="#34dcfc"
                        inactive-text=""
                        @change='contactorTwoSwitch'
                      ></el-switch>

                    </div> -->
                    <div
                      class="middle-switch"
                      style="margin-top:5%"
                    >
                      <div class="tit"><span>东增氧机：&nbsp;&nbsp;&nbsp;&nbsp;</span></div>
                      <el-switch
                        style="display: block"
                        v-model="contactorThree"
                        active-color="#13ce66"
                        inactive-color="#34dcfc"
                        inactive-text=""
                        @change='contactorThreeSwitch'
                      ></el-switch>

                    </div>
                    <div
                      class="middle-switch"
                      style="margin-top:5%"
                    >
                      <div class="tit"><span>备&nbsp;&nbsp; 用：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></div>
                      <el-switch
                        style="display: block"
                        v-model="contactorFour"
                        active-color="#13ce66"
                        inactive-color="#34dcfc"
                        inactive-text=""
                        @change='contactorFourSwitch'
                      ></el-switch>

                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span='18'>
                <div class="data-middle-three">
                  <span class="data-tit">电流实时曲线</span>
                  <div
                    class="annl"
                    style="height: 81%;"
                    ref="eqchartLine"
                  ></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="data-right-one">
            <span class="data-tit">水质实时数据</span>
            <div class="data-right-one-wather">
              <el-row
                :gutter="20"
                type="flex"
                style="min-height: 100%;"
              >
                <el-col :span="8">
                  <div
                    class="annl"
                    ref="watherOne"
                  ></div>
                </el-col>

                <el-col :span="8">
                  <div
                    class="annl"
                    ref="watherThree"
                  ></div>
                </el-col>
                <el-col :span="8">
                  <div
                    class="annl"
                    ref="watherFour"
                  ></div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="data-right-two">
            <span class="data-tit">温湿度实时曲线</span>
            <div
              class="annl"
              style="height: 85%;"
              ref="tempLine"
            ></div>
          </div>
          <div class="data-right-three">
            <span class="data-tit">位置信息</span>
            <div class="baibuMap">
              <div
                id="allmap"
                style="width: 100%;height: 100%"
              ></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import echartsLiquidfill from 'echarts-liquidfill'
import 'echarts-liquidfill'
import echarts from 'echarts'
import styleJson1 from '../../../static/baidujson/custom_map_config_blue.json'
import service from '../../service/leftService.js'

const cameraData = {
  attribute: { din: "39303637303951160047003A", device_version: "1.08", device_name: "ICUCMD", force: false },
  description: "摄像头开关",
  fullName: "微瓴平台-饱和数据测试-苏州实验室服务器-测试组-苏州测试-test3-ICUCMD-RS_WEBCAM",
  id: "61ea5e9dc490f35091120441",
  name: "RS_WEBCAM",
  parentId: "61ea5e9dc490f3509112042a",
  secondName: null,
  type: "BinaryOutput",
  unit: null,
  value: "0.00"
}
const contactorOneData = {
  attribute: { din: "39303637303951160047003A", device_version: "1.08", device_name: "ICUCMD", force: false },
  description: "西增氧机",
  fullName: "微瓴平台-饱和数据测试-苏州实验室服务器-测试组-苏州测试-test3-ICUCMD-RS_KM1",
  id: "61ea5e9dc490f35091120442",
  name: "RS_KM1",
  parentId: "61ea5e9dc490f3509112042a",
  secondName: null,
  type: "BinaryOutput",
  unit: null,
  value: "0.00"
}
const contactorTwoData = {
  attribute: {
    device_name: "ICUCMD",
    device_version: "1.07",
    din: "3130393731385115002A004C",
    force: false
  },
  description: "拌料机（常开）",
  fullName: "微瓴平台-饱和数据测试-苏州实验室服务器-测试组-苏州测试-光明渔业-ICUCMD-RS_KM2",
  id: "61de2f11c490f35091120117",
  name: "RS_KM2",
  parentId: "61de2f10c490f35091120105",
  secondName: null,
  type: "BinaryOutput",
  unit: null,
  value: "0.00"
}
const contactorThreeData = {
  attribute: { din: "39303637303951160047003A", device_version: "1.08", device_name: "ICUCMD", force: false },
  description: "东增氧机",
  fullName: "微瓴平台-饱和数据测试-苏州实验室服务器-测试组-苏州测试-test3-ICUCMD-RS_KM3",
  id: "61ea5e9dc490f35091120444",
  name: "RS_KM3",
  parentId: "61ea5e9dc490f3509112042a",
  secondName: null,
  type: "BinaryOutput",
  unit: null,
  value: "0.00",
}
const contactorFourData = {
  attribute: { din: "39303637303951160047003A", device_version: "1.08", device_name: "ICUCMD", force: false },
  description: "备用",
  fullName: "微瓴平台-饱和数据测试-苏州实验室服务器-测试组-苏州测试-test3-ICUCMD-RS_KM4",
  id: "61ea5e9dc490f35091120445",
  name: "RS_KM4",
  parentId: "61ea5e9dc490f3509112042a",
  secondName: null,
  type: "BinaryOutput",
  unit: null,
  value: "0.00"
}

export default {
  name: '',
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度 
      vedioSrc: '',
      camera: false,
      contactorOne: false,
      contactorTwo: false,
      contactorThree: false,
      contactorFour: false,
      testArray: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
      testSize: 0,
      // 黄绿红
      EIA: [],
      EIB: [],
      EIC: [],
      temp: [],
      hund: [],
      timer: null,
      form: {
        eia: '',
        eib: '',
        eic: '',
        eua: '',
        eub: '',
        euc: '',
        ep: '',
        esp: '',
        temp: '',
        humd: '',
        waterTemp: '',
        epph: '',
        epdo: '',
        ept: ''
      }
    }
  },
  props: {

  },
  components: {
  },
  mounted() {
    var map = new BMapGL.Map("allmap");    // 创建Map实例
    map.centerAndZoom(new BMapGL.Point(120.626055, 33.330302), 7);  // 初始化地图,设置中心点坐标和地图级别
    map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
    map.setMapStyleV2({ styleJson: styleJson1 });
    map.setHeading(180);
    map.setTilt(50);

    var point1 = new BMapGL.Point(120.626055, 33.330302);
    map.centerAndZoom(point1);
    var marker1 = new BMapGL.Marker(point1);  // 创建标注
    map.addOverlay(marker1);              // 将标注添加到地图中
    this.content1 = "<table>";
    this.content1 = this.content1 + `<tr><td id="tes">光明渔业：</td></tr>`;
    this.content1 = this.content1 + `<tr><td id="tes">具体位置：江苏省盐城市大丰区水产路</td></tr>`;
    this.content1 += "</table>";
    var infoWindow1 = new BMapGL.InfoWindow(this.content1);  // 创建信息窗口对象
    marker1.addEventListener("onmouseover", function () {
      map.openInfoWindow(infoWindow1, point1); //开启信息窗口
    });
    this.timer = setInterval(() => {
      this.getData()
    }, 1000)
    // 初始化echarts
    this.$nextTick(() => {
      this.echartsLine();
    });
    // 同步开关
    this.synchronizationSwitch()
  },
  created() {
    let _this = this
    this.$nextTick(function () {
      this.$ajax.post('https://open.ys7.com/api/lapp/token/get?appKey=9b0459cbbabb44bbb6dffd9f00eaaac2&appSecret=193f43adaf7c056bc5d6c99bb769fa4f', {
        appKey: '9b0459cbbabb44bbb6dffd9f00eaaac2',
        appSecret: '193f43adaf7c056bc5d6c99bb769fa4f'
      })
        .then(function (response) {
          let accessToken = response.data.data.accessToken
          _this.vedioSrc = 'https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/G91087271/1.hd.live&autoplay=1&accessToken=' + accessToken + '&id=ysopen'
        })
        .catch(function (error) {
          console.log(error);
        });
    });
  },
  methods: {
    // 获取数据
    getData() {
      let myDate = new Date();
      this.house = myDate.getHours();
      this.minutes = myDate.getMinutes();
      this.second = myDate.getSeconds();
      let time = this.house + ":" + this.minutes + ":" + this.second
      if (this.testSize > 500) {
        this.testSize = 554
        this.testArray.shift()
        this.testArray.push(time)
      } else {
        this.testArray.splice(this.testSize, 1, time)
      }
      let db = {
        "args": ['光明渔业电力接口', '光明渔业温湿度接口', '光明渔业水溶解数据接口']
      }
      service.getPublicData(db).then(resdb => {
        resdb.forEach(item => {
          if (item.name === 'EI_A') {
            this.form.eia = item.value
            if (this.testSize > 500) {
              this.EIA.shift()
              this.EIA.push(item.value)
            } else {
              this.EIA.push(item.value)
            }
          }
          if (item.name === 'EI_B') {
            this.form.eib = item.value
            if (this.testSize > 500) {
              this.EIB.shift()
              this.EIB.push(item.value)
            } else {
              this.EIB.push(item.value)
            }
          }
          if (item.name === 'EI_C') {
            this.form.eic = item.value
            if (this.testSize > 500) {
              this.EIC.shift()
              this.EIC.push(item.value)
            } else {
              this.EIC.push(item.value)
            }
          }
          if (item.name === 'EU_A') {
            this.form.eua = item.value
          }
          if (item.name === 'EU_B') {
            this.form.eub = item.value
          }
          if (item.name === 'EU_C') {
            this.form.euc = item.value
          }
          if (item.name === 'EP_Power') {
            this.form.ep = item.value
          }
          if (item.name === 'EP_Kwh') {
            this.form.esp = item.value
          }
          if (item.name === 'T_Temp') {
            this.form.temp = item.value
            this.form.waterTemp = item.value + 5
            if (this.testSize > 500) {
              this.temp.shift()
              this.temp.push(item.value)
            } else {
              this.temp.push(item.value)
            }
          }
          if (item.name === 'H_Humd') {
            this.form.humd = item.value
            if (this.testSize > 500) {
              this.hund.shift()
              this.hund.push(item.value)
            } else {
              this.hund.push(item.value)
            }
          }
          if (item.name === 'EP_PH') {
            this.form.epph = item.value
          }
          if (item.name === 'EP_DO') {
            this.form.epdo = item.value
          }
          if (item.name === 'EP_T') {
            this.form.ept = item.value
          }
        });

      }).catch(err => {
        this.$Message.error(err)
      })

      this.echartsLine()
      this.testSize++
    },
    echartsLine() {
      // 电流数据 
      let huanOne = echarts.init(this.$refs.huanOne);
      huanOne.setOption(
        {
          title: {
            show: true,
            text: this.form.eia,
            textStyle: {
              fontSize: '15px',
              color: '#e73851',
            },
            subtext: ['电流A\n'],
            itemGap: -30,
            x: 'center',
            y: 55,
            subtextStyle: {
              fontSize: '15px',
              color: '#e73851'
            }
          },

          tootip: {
            trigger: 'item',
            position: [20, '20px'],
          },
          color: ['#061f5c', '#e73851'],
          series: [
            {
              name: '访问来源',
              type: 'pie',
              radius: ['50%', '70%',],
              itemStyle: {
                normal: {
                  label: { show: false },
                  labelLine: { show: false }
                }
              },
              data: [
                { value: 10, name: '收到问题' },
                { value: this.form.eia, name: '解决问题' },
              ]
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        huanOne.resize()
      })
      let huanTwo = echarts.init(this.$refs.huanTwo);
      huanTwo.setOption(
        {
          title: {
            show: true,
            text: this.form.eib,
            textStyle: {
              fontSize: '15px',
              color: '#d1b55d',
            },
            subtext: ['电流B\n'],
            itemGap: -30,
            x: 'center',
            y: 55,
            subtextStyle: {
              fontSize: '15px',
              color: '#d1b55d'
            }
          },

          tootip: {
            trigger: 'item',
            position: [20, '20px'],
          },
          color: ['#061f5c', '#d1b55d'],
          series: [
            {
              name: '访问来源',
              type: 'pie',
              radius: ['50%', '70%',],
              itemStyle: {
                normal: {
                  label: { show: false },
                  labelLine: { show: false }
                }
              },
              data: [
                { value: 10, name: '收到问题' },
                { value: this.form.eib, name: '解决问题' },
              ]
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        huanTwo.resize()
      })
      let huanThree = echarts.init(this.$refs.huanThree);
      huanThree.setOption(
        {
          title: {
            show: true,
            text: this.form.eic,
            textStyle: {
              fontSize: '15px',
              color: '#80c9c2',
            },
            subtext: ['电流C\n'],
            itemGap: -30,
            x: 'center',
            y: 55,
            subtextStyle: {
              fontSize: '15px',
              color: '#80c9c2'
            }
          },

          tootip: {
            trigger: 'item',
            position: [20, '20px'],
          },
          color: ['#061f5c', '#80c9c2'],
          series: [
            {
              name: '访问来源',
              type: 'pie',
              radius: ['50%', '70%',],
              itemStyle: {
                normal: {
                  label: { show: false },
                  labelLine: { show: false }
                }
              },
              data: [
                { value: 10, name: '收到问题' },
                { value: this.form.eic, name: '解决问题' },
              ]
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        huanThree.resize()
      })
      // 电压柱状图
      let euLine = echarts.init(this.$refs.euLine);
      euLine.setOption(
        {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            top: '0%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            min: 0,
            max: 500,
            show: false,
            type: 'value',
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          },
          yAxis: {
            type: 'category',
            data: ['A相电压', 'B相电压', 'C相电压'],
            splitLine: { show: false },
            axisLabel: {
              textStyle: {
                color: '#34dcfc'
              }
            },
            axisLine: {
              show: false,
              color: '#34dcfc'
            },
            axisTick: {
              show: false
            },
            offset: 10,
            nameTextStyle: {
              fontSize: 15,
              color: '#34dcfc'
            }
          },
          series: [
            {
              name: '数量',
              type: 'bar',
              data: [this.form.eua, this.form.eub, this.form.euc],
              showBackground: true,
              barWidth: 14,
              barGap: 10,
              smooth: true,
              label: {
                normal: {
                  show: true,
                  position: 'right',
                  offset: [5, -2],
                  textStyle: {
                    color: '#34dcfc',
                    fontSize: 13
                  }
                }
              },
              itemStyle: {
                emphasis: {
                  barBorderRadius: 7
                },
                normal: {
                  barBorderRadius: 7,
                  color: new echarts.graphic.LinearGradient(
                    0, 0, 1, 0,
                    [
                      { offset: 0, color: '#3977E6' },
                      { offset: 1, color: '#37BBF8' }

                    ]
                  )
                }
              }
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        euLine.resize()
      })
      // 电流电压雷达图eleida
      let eleida = echarts.init(this.$refs.eleida);
      eleida.setOption(
        {
          title: {
            text: ''
          },
          legend: {
            data: []
          },
          radar: {
            // shape: 'circle',
            indicator: [
              { name: '电压A', max: 500 },
              { name: '电压B', max: 500 },
              { name: '电压C', max: 500 },
              { name: '电流A', max: 30 },
              { name: '电流B', max: 30 },
              { name: '电流C', max: 30 }
            ],
            name: {
              textStyle: { color: '#34dcfc' }
            },
            axisName: {
              color: '#34dcfc'
            },
            axisLine: {
              show: false,
            }
          },
          series: [
            {
              name: 'Budget vs spending',
              type: 'radar',
              itemStyle: {
                color: '#34dcfc'
              },
              areaStyle: {
                normal: {
                  opacity: 0.5,  //背景透明
                },
              },
              data: [
                {
                  value: [this.form.eua, this.form.eub, this.form.euc, this.form.eia, this.form.eib, this.form.eic],
                  name: '电流'
                },
              ]
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        eleida.resize()
      })
      // 电流实时曲线
      let eqchartLine = echarts.init(this.$refs.eqchartLine);
      eqchartLine.setOption(
        {
          title: {
            textStyle: {
              align: 'right',
              color: '#ffffff',
              fontSize: 12,
            },
            top: '1%',
            left: 'left',
          },
          backgroundColor: '',
          grid: {
            left: '2%',
            right: '2%',
            top: '20%',
            bottom: '1%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            show: true,
            x: 'center',
            y: '0',
            textStyle: {
              color: '#1bb4f6'
            },
            data: ['电流A', '电流B', '电流C']
          },
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              color: "#34dcfc"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#34dcfc'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#34dcfc'
              }
            },
            data: this.testArray
          }],
          yAxis: [{
            type: 'value',
            name: '',
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: '#34dcfc'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#34dcfc'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#11366e'
              }
            }
          },

          ],
          series: [{
            name: '电流A',
            type: 'line',
            symbol: 'none',
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: '#ff9203',
                lineStyle: {
                  color: "#ff9203",
                  width: 1
                },
              }
            },
            markPoint: {
              itemStyle: {
                normal: {
                  color: '#ff9203'
                }
              }
            },
            data: this.EIA
          },
          {
            name: '电流B',
            type: 'line',
            symbol: 'none',
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: '#ffee00',
                lineStyle: {
                  color: "#ffee00",
                  width: 1
                },
              }
            },
            markPoint: {
              itemStyle: {
                normal: {
                  color: 'red'
                }
              }
            },
            data: this.EIB
          },
          {
            name: '电流C',
            type: 'line',
            symbol: 'none',
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: '#34dcfc',
                lineStyle: {
                  color: "#34dcfc",
                  width: 1
                },
              }
            },
            markPoint: {
              itemStyle: {
                normal: {
                  color: '34dcfc'
                }
              }
            },
            data: this.EIC
          },
          ]
        }
      )
      window.addEventListener('resize', () => {
        eqchartLine.resize()
      })
      // 温湿度水球图
      let watherOne = echarts.init(this.$refs.watherOne);
      watherOne.setOption(
        {
          title: [
            {
              text: 'PH',
              x: '45%',
              y: 43,
              textAlign: 'center',
              textStyle: {
                fontSize: '14',
                fontWeight: '400',
                color: '#3bbaff',
                textAlign: 'center',
                fontFamily: 'PingFangSC-Regular, PingFang SC',
              },
            },
            {
              top: '49%',
              left: 'center',
              text: this.form.epph,
              textStyle: {
                color: '#3bbaff',
                fontStyle: 'normal',
                fontWeight: '400',
                fontFamily: 'PingFangSC-Regular, PingFang SC',
                fontSize: 15,
              },
            },
          ],
          series: [
            {
              type: 'liquidFill',
              itemStyle: {
                opacity: 0.8, //波浪的透明度
                shadowBlur: 10, //波浪的阴影范围
                shadowColor: '#5ca6ff', //阴影颜色
              },
              radius: '80%',
              //水波
              color: ['rgb(28,58,154)', 'rgb(28,58,154)'],
              data: [parseFloat(this.form.epph) / 100, parseFloat(this.form.epph) / 100],
              // background: '#000',
              center: ['50%', '52%'],
              backgroundStyle: {
                color: 'transparent',
              },
              label: {
                normal: {
                  formatter: '',
                  textStyle: {
                    fontSize: 12,
                  },
                },
              },
              outline: {
                itemStyle: {
                  borderColor: 'transparent',
                  borderWidth: 5,
                },
                borderDistance: 0,
              },
            },
            //外环线
            {
              color: ['#0d0c9a', 'rgb(28,58,154)'],
              type: 'pie',
              center: ['50%', '52%'],
              radius: ['80%', '84%'],
              hoverAnimation: false,
              data: [
                {
                  name: '',
                  value: 50,
                  label: {
                    show: false,
                    position: 'center',
                    color: '#2569ff',
                    fontSize: 38,
                    fontWeight: 'bold',
                    formatter: function (o) {
                      return 50;
                    },
                  },
                  labelLine: {
                    show: false,
                  },
                },
                {
                  //画剩余的刻度圆环
                  name: '',
                  value: 100 - 50,
                  label: {
                    show: false,
                  },
                  labelLine: {
                    normal: {
                      show: false,
                    },
                    emphasis: {
                      show: false,
                    },
                  },
                },
              ],
            },
          ],
        }
      )
      window.addEventListener('resize', () => {
        watherOne.resize()
      })
      /* let watherTwo = echarts.init(this.$refs.watherTwo);
      watherTwo.setOption(
        {
          title: [
            {
              text: '湿度',
              x: '45%',
              y: 43,
              textAlign: 'center',
              textStyle: {
                fontSize: '14',
                fontWeight: '400',
                color: '#3bbaff',
                textAlign: 'center',
                fontFamily: 'PingFangSC-Regular, PingFang SC',
              },
            },
            {
              top: '49%',
              left: 'center',
              text: this.form.humd + '%',
              textStyle: {
                color: '#3bbaff',
                fontStyle: 'normal',
                fontWeight: '400',
                fontFamily: 'PingFangSC-Regular, PingFang SC',
                fontSize: 15,
              },
            },
          ],
          series: [
            {
              type: 'liquidFill',
              itemStyle: {
                opacity: 0.8, //波浪的透明度
                shadowBlur: 10, //波浪的阴影范围
                shadowColor: '#5ca6ff', //阴影颜色
              },
              radius: '80%',
              //水波
              color: ['rgb(28,58,154)', 'rgb(28,58,154)'],
              data: [parseFloat(this.form.humd) / 100, parseFloat(this.form.humd) / 100],
              // background: '#000',
              center: ['50%', '52%'],
              backgroundStyle: {
                color: 'transparent',
              },
              label: {
                normal: {
                  formatter: '',
                  textStyle: {
                    fontSize: 12,
                  },
                },
              },
              outline: {
                itemStyle: {
                  borderColor: 'transparent',
                  borderWidth: 5,
                },
                borderDistance: 0,
              },
            },
            //外环线
            {
              color: ['#0d0c9a', 'rgb(28,58,154)'],
              type: 'pie',
              center: ['50%', '52%'],
              radius: ['80%', '84%'],
              hoverAnimation: false,
              data: [
                {
                  name: '',
                  value: 50,
                  label: {
                    show: false,
                    position: 'center',
                    color: '#2569ff',
                    fontSize: 38,
                    fontWeight: 'bold',
                    formatter: function (o) {
                      return 50;
                    },
                  },
                  labelLine: {
                    show: false,
                  },
                },
                {
                  //画剩余的刻度圆环
                  name: '',
                  value: 100 - 50,
                  label: {
                    show: false,
                  },
                  labelLine: {
                    normal: {
                      show: false,
                    },
                    emphasis: {
                      show: false,
                    },
                  },
                },
              ],
            },
          ],
        }
      )
      window.addEventListener('resize', () => {
        watherTwo.resize()
      }) */
      let watherThree = echarts.init(this.$refs.watherThree);
      watherThree.setOption(
        {
          title: [
            {
              text: '溶解氧',
              x: '45%',
              y: 43,
              textAlign: 'center',
              textStyle: {
                fontSize: '14',
                fontWeight: '400',
                color: '#3bbaff',
                textAlign: 'center',
                fontFamily: 'PingFangSC-Regular, PingFang SC',
              },
            },
            {
              top: '49%',
              left: 'center',
              text: this.form.epdo + "mg/L",
              textStyle: {
                color: '#3bbaff',
                fontStyle: 'normal',
                fontWeight: '400',
                fontFamily: 'PingFangSC-Regular, PingFang SC',
                fontSize: 15,
              },
            },
          ],
          series: [
            {
              type: 'liquidFill',
              itemStyle: {
                opacity: 0.8, //波浪的透明度
                shadowBlur: 10, //波浪的阴影范围
                shadowColor: '#5ca6ff', //阴影颜色
              },
              radius: '80%',
              //水波
              color: ['rgb(28,58,154)', 'rgb(28,58,154)'],
              data: [parseFloat(this.form.epdo) / 100, parseFloat(this.form.epdo) / 100],
              // background: '#000',
              center: ['50%', '52%'],
              backgroundStyle: {
                color: 'transparent',
              },
              label: {
                normal: {
                  formatter: '',
                  textStyle: {
                    fontSize: 12,
                  },
                },
              },
              outline: {
                itemStyle: {
                  borderColor: 'transparent',
                  borderWidth: 5,
                },
                borderDistance: 0,
              },
            },
            //外环线
            {
              color: ['#0d0c9a', 'rgb(28,58,154)'],
              type: 'pie',
              center: ['50%', '52%'],
              radius: ['80%', '84%'],
              hoverAnimation: false,
              data: [
                {
                  name: '',
                  value: 50,
                  label: {
                    show: false,
                    position: 'center',
                    color: '#2569ff',
                    fontSize: 38,
                    fontWeight: 'bold',
                    formatter: function (o) {
                      return 50;
                    },
                  },
                  labelLine: {
                    show: false,
                  },
                },
                {
                  //画剩余的刻度圆环
                  name: '',
                  value: 100 - 50,
                  label: {
                    show: false,
                  },
                  labelLine: {
                    normal: {
                      show: false,
                    },
                    emphasis: {
                      show: false,
                    },
                  },
                },
              ],
            },
          ],
        }
      )
      window.addEventListener('resize', () => {
        watherThree.resize()
      })
      let watherFour = echarts.init(this.$refs.watherFour);
      watherFour.setOption(
        {
          title: [
            {
              text: '水温',
              x: '45%',
              y: 43,
              textAlign: 'center',
              textStyle: {
                fontSize: '14',
                fontWeight: '400',
                color: '#3bbaff',
                textAlign: 'center',
                fontFamily: 'PingFangSC-Regular, PingFang SC',
              },
            },
            {
              top: '49%',
              left: 'center',
              text: this.form.ept + '℃',
              textStyle: {
                color: '#3bbaff',
                fontStyle: 'normal',
                fontWeight: '400',
                fontFamily: 'PingFangSC-Regular, PingFang SC',
                fontSize: 15,
              },
            },
          ],
          series: [
            {
              type: 'liquidFill',
              itemStyle: {
                opacity: 0.8, //波浪的透明度
                shadowBlur: 10, //波浪的阴影范围
                shadowColor: '#5ca6ff', //阴影颜色
              },
              radius: '80%',
              //水波
              color: ['rgb(28,58,154)', 'rgb(28,58,154)'],
              data: [parseFloat(this.form.ept) / 100, parseFloat(this.form.ept) / 100],
              // background: '#000',
              center: ['50%', '52%'],
              backgroundStyle: {
                color: 'transparent',
              },
              label: {
                normal: {
                  formatter: '',
                  textStyle: {
                    fontSize: 12,
                  },
                },
              },
              outline: {
                itemStyle: {
                  borderColor: 'transparent',
                  borderWidth: 5,
                },
                borderDistance: 0,
              },
            },
            //外环线
            {
              color: ['#0d0c9a', 'rgb(28,58,154)'],
              type: 'pie',
              center: ['50%', '52%'],
              radius: ['80%', '84%'],
              hoverAnimation: false,
              data: [
                {
                  name: '',
                  value: 50,
                  label: {
                    show: false,
                    position: 'center',
                    color: '#2569ff',
                    fontSize: 38,
                    fontWeight: 'bold',
                    formatter: function (o) {
                      return 50;
                    },
                  },
                  labelLine: {
                    show: false,
                  },
                },
                {
                  //画剩余的刻度圆环
                  name: '',
                  value: 100 - 50,
                  label: {
                    show: false,
                  },
                  labelLine: {
                    normal: {
                      show: false,
                    },
                    emphasis: {
                      show: false,
                    },
                  },
                },
              ],
            },
          ],
        }
      )
      window.addEventListener('resize', () => {
        watherFour.resize()
      })
      // 温湿度实时曲线
      let tempLine = echarts.init(this.$refs.tempLine);
      tempLine.setOption(
        {
          title: {
            textStyle: {
              align: 'right',
              color: '#ffffff',
              fontSize: 12,
            },
            top: '1%',
            left: 'left',
          },
          backgroundColor: '',
          grid: {
            left: '2%',
            right: '2%',
            top: '20%',
            bottom: '1%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            show: true,
            x: 'center',
            y: '0',
            textStyle: {
              color: '#1bb4f6'
            },
            data: ['温度', '湿度']
          },
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              color: "#34dcfc"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#34dcfc'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#34dcfc'
              }
            },
            data: this.testArray
          }],
          yAxis: [{
            type: 'value',
            name: '',
            min: 0,
            max: 100,
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: '#34dcfc'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#34dcfc'
              }
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#11366e'
              }
            }
          },

          ],
          series: [
            {
              name: '温度',
              type: 'line',
              symbol: 'none',
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: '#ffee00',
                  lineStyle: {
                    color: "#ffee00",
                    width: 1
                  },
                }
              },
              markPoint: {
                itemStyle: {
                  normal: {
                    color: 'red'
                  }
                }
              },
              data: this.temp
            },
            {
              name: '湿度',
              type: 'line',
              symbol: 'none',
              symbolSize: 8,
              itemStyle: {
                normal: {
                  color: '#34dcfc',
                  lineStyle: {
                    color: "#34dcfc",
                    width: 1
                  },
                }
              },
              markPoint: {
                itemStyle: {
                  normal: {
                    color: '34dcfc'
                  }
                }
              },
              data: this.hund
            },
          ]
        }
      )
      window.addEventListener('resize', () => {
        tempLine.resize()
      })
    },
    // 摄像头开关
    cameraSwitch() {
      if (this.camera) {
        let _this = this
        cameraData.value = 1
        service.updatePointData(cameraData).then(res => {
          this.$Message.success('摄像头打开成功,将在40秒后加载')
          setTimeout(() => {
            document.getElementById('vid').src = _this.vedioSrc
          }, 40000)
        }).catch(err => {
          this.$Message.error('摄像头打开失败')
        })

      } else {
        cameraData.value = 0
        service.updatePointData(cameraData).then(res => {
          this.$Message.success('摄像头关闭成功')
        }).catch(err => {
          this.$Message.error('摄像头关闭失败')
        })
      }
    },
    // 接触器1
    contactorOneSwitch() {
      if (this.contactorOne) {
        contactorOneData.value = 1
        service.updatePointData(contactorOneData).then(res => {
          this.$Message.success('西增氧机打开成功')
        }).catch(err => {
          this.$Message.error('西增氧机打开失败')
        })
      } else {
        contactorOneData.value = 0
        service.updatePointData(contactorOneData).then(res => {
          this.$Message.success('西增氧机关闭成功')
        }).catch(err => {
          this.$Message.error('西增氧机关闭失败')
        })
      }
    },
    // 接触器2
    contactorTwoSwitch() {
      if (this.contactorTwo) {
        contactorTwoData.value = 1
        service.updatePointData(contactorTwoData).then(res => {
          this.$Message.success('拌料机打开成功')
        }).catch(err => {
          this.$Message.error('拌料机打开失败')
        })
      } else {
        contactorTwoData.value = 0
        service.updatePointData(contactorTwoData).then(res => {
          this.$Message.success('拌料机关闭成功')
        }).catch(err => {
          this.$Message.error('拌料机关闭失败')
        })
      }
    },
    // 接触器3
    contactorThreeSwitch() {
      if (this.contactorThree) {
        contactorThreeData.value = 1
        service.updatePointData(contactorThreeData).then(res => {
          this.$Message.success('东增氧机打开成功')
        }).catch(err => {
          this.$Message.error('东增氧机打开失败')
        })
      } else {
        contactorThreeData.value = 0
        service.updatePointData(contactorThreeData).then(res => {
          this.$Message.success('东增氧机关闭成功')
        }).catch(err => {
          this.$Message.error('东增氧机关闭失败')
        })
      }
    },
    // 接触器4
    contactorFourSwitch() {
      if (this.contactorFour) {
        contactorFourData.value = 1
        service.updatePointData(contactorFourData).then(res => {
          this.$Message.success('成功')
        }).catch(err => {
          this.$Message.error('失败')
        })
      } else {
        contactorFourData.value = 0
        service.updatePointData(contactorFourData).then(res => {
          this.$Message.success('成功')
        }).catch(err => {
          this.$Message.error('失败')
        })
      }
    },
    // 初始化同步开关
    synchronizationSwitch() {
      let switchData = {
        "args": ['光明渔业开关数据']
      }
      service.getPublicData(switchData).then(res => {
        res.forEach(item => {
          if (item.name === 'RS_WEBCAM') {
            if (item.value === '0.00') {
              this.camera = false
            } else {
              this.camera = true
            }
          }
          if (item.name === 'RS_KM1') {
            if (item.value === '0.00') {
              this.contactorOne = false
            } else {
              this.contactorOne = true
            }
          }
          if (item.name === 'RS_KM2') {
            if (item.value === '0.00') {
              this.contactorTwo = false
            } else {
              this.contactorTwo = true
            }
          }
          if (item.name === 'RS_KM3') {
            if (item.value === '0.00') {
              this.contactorThree = false
            } else {
              this.contactorThree = true
            }
          }
          if (item.name === 'RS_KM4') {
            if (item.value === '0.00') {
              this.contactorFour = false
            } else {
              this.contactorFour = true
            }
          }
        })
      })
    },
    // 退出
    goOut() {
      this.$router.go(-1)
    }
  },
  destroyed() {
    clearInterval(this.timer)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  position: relative;
  background-image: url("/static/img/fisheries/bg.png");
  background-size: 100% 100%;
  overflow-y: auto;
}
.content-hander {
  width: 100%;
  min-height: 8%;
  display: flex;
  text-align: center;
  background-image: url("/static/img/fisheries/mian-title.png");
  background-size: 100% 100%;
}
.content-main-title {
  font-size: 4vh;
  font-weight: 900;
  margin-left: 42%;
  font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
  background-image: -webkit-linear-gradient(bottom, #024ec0, #84ebfd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.content-data {
  width: 100%;
  height: 91%;
  padding: 10px 10px;
}
.data-left-one {
  width: 100%;
  height: 18%;
  background-image: url("/static/img/fisheries/plan-left-top.png");
  background-size: 100% 100%;
}
.data-left-two {
  width: 100%;
  height: 25%;
  margin-top: 20px;
  background-image: url("/static/img/fisheries/plan-left-top.png");
  background-size: 100% 100%;
}
.data-left-three {
  width: 100%;
  height: 10%;
  margin-top: 20px;
  background-image: url("/static/img/fisheries/plan-left-two.png");
  background-size: 100% 100%;
}
.data-left-four {
  width: 100%;
  height: 37%;
  margin-top: 20px;
  background-image: url("/static/img/fisheries/plan-left-three.png");
  background-size: 100% 100%;
}
.data-middle-one {
  width: 100%;
  height: 62%;
  background-image: url("/static/img/fisheries/plan-middle-one.png");
  background-size: 100% 100%;
  position: relative;
}
.data-middle-main-two {
  width: 100%;
  height: 36%;
}
.data-middle-two {
  width: 100%;
  height: 90%;
  margin-top: 20px;
  background-image: url("/static/img/fisheries/plan-middle-two.png");
  background-size: 100% 100%;
}
.data-middle-three {
  width: 100%;
  height: 90%;
  margin-top: 20px;
  background-image: url("/static/img/fisheries/plan-middle-three.png");
  background-size: 100% 100%;
}
.data-right-one {
  width: 100%;
  height: 25%;
  background-image: url("/static/img/fisheries/plan-middle-three.png");
  background-size: 100% 100%;
}
.data-right-two {
  width: 100%;
  height: 25%;
  margin-top: 20px;
  background-image: url("/static/img/fisheries/plan-middle-three.png");
  background-size: 100% 100%;
}
.data-right-three {
  width: 100%;
  height: 42.5%;
  margin-top: 20px;
  background-image: url("/static/img/fisheries/plan-right-one.png");
  background-size: 100% 100%;
}
.data-tit {
  font-size: 1.5vh;
  color: #34dcfc;
  letter-spacing: 5px;
}
.annl {
  width: 100%;
  height: 100%;
}
.data-left-one-echarts {
  width: 100%;
  height: 81%;
  padding: 5px 5px;
}
.data-left-two-echarts {
  width: 100%;
  height: 81%;
  padding: 15px 15px;
}
.eu-data {
  width: 100%;
  height: 100%;
  background-image: url("/static/img/fisheries/plan-data.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 1.5vh;
  color: #34dcfc;
}
.eq-data {
  width: 40%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 1.5vh;
  color: #34dcfc;
}
.data-left-three-eq {
  width: 100%;
  height: 70%;
  display: flex;
  align-items: center;
  justify-items: center;
}
.eq-gif-left {
  width: 20%;
  height: 100%;
  margin-left: 6%;
  background-image: url("/static/img/fisheries/功率.gif");
  background-size: 100% 100%;
  transform: rotate(270deg);
}
.eq-gif-right {
  width: 20%;
  height: 100%;
  background-image: url("/static/img/fisheries/功率.gif");
  background-size: 100% 100%;
  transform: rotate(90deg);
}
.middle-video {
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  position: absolute;
  z-index: 1;
}
.data-middle-two-switch {
  width: 100%;
  height: 82%;
  padding: 15px 15px;
}
.middle-switch {
  width: 100%;
  height: 15%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
}
.baibuMap {
  width: 100%;
  height: 93%;
  padding: 15px 15px;
}
.data-right-one-wather {
  width: 100%;
  height: 80%;
  padding: 15px 15px;
}
.content-hander-button {
  width: 100px;
  height: 38px;
  margin-top: 7px;
  margin-left: 33%;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  background-image: url("/static/img/fisheries/button.png");
  background-size: 100% 100%;
}
.hander-button-tit {
  color: #34dcfc;
}
.tit {
  color: #34dcfc;
}
.test {
  color: #ff9203;
  color: #072162;
}
</style>


// WEBPACK FOOTER //
// src/components/graphically/fishe.vue